import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

const CSV_EXTENSION = '.csv';

class ExcelService {
    importFromFile(bstr, sheet) {
        /* read workbook */
        const wb = XLSX.read(bstr, {
            type: 'binary', cellDates: true,
            dateNF: 'dd/MM/yyyy' 
        });

        /* grab first sheet */
        const wsname = wb.SheetNames[sheet];
        const ws = wb.Sheets[wsname];

        /* save data */
        const data = (XLSX.utils.sheet_to_json(ws, { raw: false, header: 1 }));

        return data;
    }

    saveAsCsvFile(data, fileName, delimiter = ';') {
        const worksheet = XLSX.utils.json_to_sheet(data);
        const csvOutput = XLSX.utils.sheet_to_csv(worksheet, {FS: delimiter});
        const blob = new Blob(['\ufeff', csvOutput], { type: 'text/plain; charset=ISO-8859-1' });
        FileSaver.saveAs(
          blob,
          fileName + '_export_' + new Date().getTime() + CSV_EXTENSION);
      }

  }
  
  export default new ExcelService();